var map = {
	"./Asset 15.svg": 1483,
	"./Asset 9.svg": 1484,
	"./BackArrow.svg": 1485,
	"./CreateNewBrand.png": 396,
	"./Group 88.svg": 1486,
	"./Platform=Spotify.svg": 1487,
	"./PreSaves.svg": 1488,
	"./SYMPHONY.png": 1489,
	"./add-artist-profile.svg": 1490,
	"./add-icon.svg": 1491,
	"./apple_music.svg": 669,
	"./arrow-left.png": 1492,
	"./arrow-red.svg": 1493,
	"./arrow-right-icon.svg": 681,
	"./arrowRight.svg": 1494,
	"./at-icon.svg": 1495,
	"./audiomack.svg": 1496,
	"./automated-marketing-tools-mobile.png": 633,
	"./automated-marketing-tools.png": 632,
	"./automated.svg": 1497,
	"./back.svg": 1498,
	"./black-left-arrow.svg": 1499,
	"./black-right-arrow.svg": 1500,
	"./boost-white.svg": 1501,
	"./boxes-icon-white.svg": 664,
	"./boxes-icon.svg": 663,
	"./brandsintown.svg": 1502,
	"./calendar-email-campaign.svg": 1503,
	"./calendar.svg": 1504,
	"./calender.svg": 1505,
	"./campaignDetails/Boost.svg": 1506,
	"./campaignDetails/Path.svg": 1507,
	"./campaignDetails/Temporary-Component.png": 1508,
	"./campaignDetails/add.svg": 1509,
	"./campaignDetails/appleMusicGrey.svg": 1510,
	"./campaignDetails/bullet-list.svg": 1511,
	"./campaignDetails/chat.svg": 1512,
	"./campaignDetails/chevron.svg": 1513,
	"./campaignDetails/click.svg": 1514,
	"./campaignDetails/close.svg": 1515,
	"./campaignDetails/comments.svg": 1516,
	"./campaignDetails/deezerGrey.svg": 1517,
	"./campaignDetails/duplicate.svg": 1518,
	"./campaignDetails/eye.svg": 1519,
	"./campaignDetails/globe.svg": 1520,
	"./campaignDetails/heart.svg": 1521,
	"./campaignDetails/impactBlurredChart.png": 863,
	"./campaignDetails/impactBlurredCountries.png": 319,
	"./campaignDetails/impactBlurredDemographics.png": 675,
	"./campaignDetails/impactBlurredInstagram.png": 1522,
	"./campaignDetails/impactBlurredShazam.png": 1523,
	"./campaignDetails/impactBlurredSpotify.png": 862,
	"./campaignDetails/inkyLaptop.svg": 1524,
	"./campaignDetails/instagram-purple.svg": 1525,
	"./campaignDetails/link.svg": 1526,
	"./campaignDetails/location.svg": 1527,
	"./campaignDetails/money.svg": 1528,
	"./campaignDetails/paperplane.svg": 1529,
	"./campaignDetails/pause.svg": 1530,
	"./campaignDetails/performanceBlurredFbStats1.png": 1531,
	"./campaignDetails/performanceBlurredFbStats2.png": 1532,
	"./campaignDetails/performanceBlurredFbStats3.png": 1533,
	"./campaignDetails/performanceBlurredFbStats4.png": 1534,
	"./campaignDetails/performanceBlurredPlatformStats1.png": 1535,
	"./campaignDetails/performanceBlurredPlatformStats2.png": 1536,
	"./campaignDetails/play.svg": 1537,
	"./campaignDetails/soundCloudGrey.svg": 1538,
	"./campaignDetails/spotifyGrey.svg": 1539,
	"./campaignDetails/spotifyHeadphones.png": 1540,
	"./campaignDetails/swipeUpArrow.svg": 1541,
	"./campaignDetails/warning.svg": 1542,
	"./campaignDetails/youtubeGrey.svg": 1543,
	"./campaigns/boost_ig.png": 616,
	"./campaigns/ig_profile_visits.png": 617,
	"./campaigns/linkclicks.png": 619,
	"./campaigns/musicstreams.png": 392,
	"./campaigns/playlistfollowers.png": 618,
	"./campaigns/playlisting.png": 393,
	"./campaigns/presave.png": 614,
	"./campaigns/tiktok-views.png": 624,
	"./campaigns/tiktok-visits.png": 625,
	"./campaigns/videoviews-old.png": 615,
	"./campaigns/videoviews.png": 1544,
	"./campaigns/youtube.png": 1545,
	"./cariaus-album-1.svg": 1546,
	"./carret-up.svg": 1547,
	"./chartmetric.svg": 1548,
	"./check-black.svg": 1549,
	"./check-green.svg": 1550,
	"./check.png": 1551,
	"./checkbox.svg": 1552,
	"./checkboxChecked.svg": 1553,
	"./chevron-down-arrow-icon.svg": 1554,
	"./chevronDown.svg": 1555,
	"./chevronLeft.svg": 1556,
	"./chevronRight-gray.svg": 1557,
	"./chevronRight.svg": 1558,
	"./circled-add.svg": 1559,
	"./circled-less.svg": 1560,
	"./click-gray.svg": 1561,
	"./click.svg": 1562,
	"./clock.svg": 1563,
	"./close-black.svg": 1564,
	"./close.svg": 1565,
	"./closeIcon.svg": 1566,
	"./closew.svg": 1567,
	"./contextualMenu.svg": 1568,
	"./conversions-chart.png": 1569,
	"./crown.svg": 1570,
	"./custom_link.svg": 1571,
	"./dashboardIcon.svg": 1572,
	"./down-gray-arrow.svg": 639,
	"./download-2.svg": 1573,
	"./drag-and-drop-icon.svg": 1574,
	"./drag.svg": 1575,
	"./dropdown-arrow-black.svg": 1576,
	"./dropdown-arrow.svg": 1577,
	"./duplicate.svg": 1578,
	"./edit-purple.svg": 1579,
	"./edit.svg": 1580,
	"./email_fans.svg": 1581,
	"./email_presave.svg": 1582,
	"./email_purple.svg": 1583,
	"./empty-state/desktop-graph-preview.png": 891,
	"./empty-state/mobile-graph-preview.png": 890,
	"./empty-user-pink.png": 1584,
	"./equal.svg": 1585,
	"./error-close-red.svg": 1586,
	"./external-link.svg": 1587,
	"./facebook-i.svg": 1588,
	"./facebook-rounded-icon.svg": 628,
	"./facebook.svg": 1589,
	"./facebookPixel.svg": 1590,
	"./fanbaseTable/location.svg": 657,
	"./fanbaseTable/name.svg": 658,
	"./fanbaseTable/source.svg": 1591,
	"./fanbaseTasks/PresaveCreatedIcon.svg": 1592,
	"./fans.svg": 1593,
	"./fb-small-icon.png": 1594,
	"./fb-token-expired.png": 676,
	"./file-icon.svg": 1595,
	"./fire.svg": 1596,
	"./flying-rocket.svg": 1597,
	"./gem-icon-navbar.svg": 1598,
	"./gem-icon-purple.svg": 1599,
	"./gem-icon-yellow.svg": 1600,
	"./gettingStarted/InstagramEngagement.svg": 1601,
	"./gettingStarted/completeYourFanbase.png": 682,
	"./gettingStarted/customizeYourWebsite.png": 683,
	"./gettingStarted/dollar_sign.svg": 1602,
	"./gettingStarted/growYoutubeEngagements.png": 1603,
	"./gettingStarted/inviteYourTeam.png": 1604,
	"./gettingStarted/startCampaign.png": 1605,
	"./globe.svg": 1606,
	"./google.svg": 1607,
	"./googleanalytics.svg": 1608,
	"./green-chrome-outline.svg": 1609,
	"./grow-instagram-logo.svg": 1610,
	"./headphones.svg": 1611,
	"./ig-comments.svg": 1612,
	"./ig-increment.png": 1613,
	"./ig-likes.svg": 1614,
	"./ig-small-icon.png": 1615,
	"./ig-video.svg": 1616,
	"./image.svg": 680,
	"./img-placeholder.svg": 1617,
	"./info.svg": 1618,
	"./inkyLaptop.svg": 1619,
	"./insta.svg": 640,
	"./instagram-bordered-icon.svg": 630,
	"./instagram-bordered-white.svg": 1620,
	"./instagram-bw.svg": 629,
	"./instagram-gold.svg": 1621,
	"./instagram-green.svg": 1622,
	"./instagram-red.svg": 1623,
	"./lightning.svg": 1624,
	"./link-clicks.svg": 1625,
	"./link-gray.svg": 1626,
	"./linked.svg": 1627,
	"./logo.svg": 1628,
	"./logos/sidebar-collapsed.png": 242,
	"./logos/symphony-badge-black.png": 637,
	"./logos/symphony-badge-purple.png": 636,
	"./lotties/GetStarted": 159,
	"./lotties/GetStarted.json": 159,
	"./lotties/SymphonyLoading": 233,
	"./lotties/SymphonyLoading.json": 233,
	"./lotties/SymphonyLoading_Gray": 892,
	"./lotties/SymphonyLoading_Gray.json": 892,
	"./lotties/SymphonyLoading_White": 391,
	"./lotties/SymphonyLoading_White.json": 391,
	"./maestro/maestro-ai-tag.svg": 1629,
	"./maestro/maestro-background.png": 1630,
	"./maestro/maestro-chart-temp.svg": 1631,
	"./maestro/maestro-logo.svg": 326,
	"./maestro/star-score-filled.svg": 634,
	"./maestro/star-score-outline.svg": 635,
	"./mail.svg": 1632,
	"./marketingIcon-gray.svg": 1633,
	"./marketingIcon.svg": 1634,
	"./money-purple.svg": 1635,
	"./money.svg": 1636,
	"./music-key-green-bg.svg": 238,
	"./music-key-green.svg": 1637,
	"./music-key.svg": 1638,
	"./music-player.svg": 316,
	"./no-image-available.svg": 611,
	"./not-found-user.png": 672,
	"./on@2x.png": 1639,
	"./onboarding.jpeg": 1640,
	"./onboarding/Artist_cover.png": 1641,
	"./onboarding/Chart1.png": 1642,
	"./onboarding/Chart2.png": 1643,
	"./onboarding/Chart3.png": 1644,
	"./onboarding/GetStarted": 893,
	"./onboarding/GetStarted.json": 893,
	"./onboarding/SecondStepImage.png": 1645,
	"./onboarding/data-examples/boosts-example.png": 1646,
	"./onboarding/data-examples/countries-example.png": 1647,
	"./onboarding/data-examples/demographics-example.png": 1648,
	"./onboarding/data-examples/dsp-breakdown-example.png": 1649,
	"./onboarding/data-examples/email-list-example.png": 1650,
	"./onboarding/data-examples/growth-example.png": 1651,
	"./onboarding/data-examples/playlisting-example.png": 1652,
	"./onboarding/data-examples/playlists-example.png": 1653,
	"./onboarding/data-examples/presave-countries-example.png": 1654,
	"./onboarding/data-examples/shazams-example.png": 1655,
	"./onboarding/data-examples/spotify-followers-example.png": 1656,
	"./onboarding/data-examples/spotify-streams-example.png": 1657,
	"./onboarding/data-examples/video-views-example.png": 1658,
	"./onboarding/inky-arrow.png": 1659,
	"./onboarding/slide1.png": 1660,
	"./onboarding/slide2.png": 1661,
	"./onboarding/soundCloudWhite.svg": 1662,
	"./orange-ig-icon.png": 1663,
	"./order.svg": 350,
	"./outlinedStar.svg": 1664,
	"./p-3.svg": 1665,
	"./p-4.svg": 1666,
	"./p1.svg": 1667,
	"./p2.svg": 1668,
	"./paper-plane.svg": 1669,
	"./pause-purple.svg": 1670,
	"./paypal-icon.png": 1671,
	"./pexels-vinícius-caricatte.svg": 1672,
	"./piano-bg.jpg": 1673,
	"./placeholders/artwork-empty.png": 1674,
	"./placeholders/musical-note.png": 671,
	"./placeholders/tableImage.png": 684,
	"./platforms/amazon-music.svg": 627,
	"./platforms/anghami.svg": 631,
	"./platforms/apple.svg": 626,
	"./platforms/audiomack.svg": 275,
	"./platforms/bandsintown.svg": 678,
	"./platforms/bandsintown_icon.svg": 677,
	"./platforms/deezer.svg": 382,
	"./platforms/facebook.svg": 386,
	"./platforms/fans.svg": 387,
	"./platforms/forever-saves.svg": 388,
	"./platforms/instagram.svg": 384,
	"./platforms/soundcloud.svg": 274,
	"./platforms/spotify.svg": 315,
	"./platforms/tidal.svg": 459,
	"./platforms/tiktok.svg": 385,
	"./platforms/yandex.svg": 1675,
	"./platforms/youtube.svg": 383,
	"./play-purple.svg": 1676,
	"./playlisting/100k.png": 894,
	"./playlisting/1mil.png": 895,
	"./playlisting/300k.png": 896,
	"./playlisting/30k.png": 897,
	"./playlisting/600k.png": 898,
	"./plus.svg": 1677,
	"./profileIcon.svg": 115,
	"./question-mark.svg": 212,
	"./recommendation-card-blurred-background.png": 571,
	"./recommendations/ads.png": 469,
	"./recommendations/presave.png": 608,
	"./recommendations/website.png": 607,
	"./referral-tasks/twitter.png": 685,
	"./reload.svg": 1678,
	"./right-arrow-right.svg": 1679,
	"./right-arrow.svg": 781,
	"./sample-upload-1.svg": 1680,
	"./search-icon-2.svg": 1681,
	"./search-icon.svg": 899,
	"./settingIcon.svg": 1682,
	"./settingsScreen/emptyInvoices.svg": 1683,
	"./settingsScreen/proSucceeded.png": 774,
	"./settingsScreen/upArrow.svg": 1684,
	"./shazam.svg": 1685,
	"./smoking-laptop.png": 349,
	"./soundcloud-bw.svg": 1686,
	"./soundcloud.svg": 1687,
	"./sparkles.svg": 1688,
	"./speech-bubble-message.svg": 1689,
	"./spotify-bw.svg": 1690,
	"./spotify.svg": 1691,
	"./stacked-icon-white.svg": 666,
	"./stacked-icon.svg": 665,
	"./stars-icon.svg": 641,
	"./streaming/icons/apple-icon.svg": 1692,
	"./streaming/icons/audiomack-icon.svg": 1693,
	"./streaming/icons/bandcamp.svg": 1694,
	"./streaming/icons/deezer-icon.svg": 670,
	"./streaming/icons/soundcloud-icon.svg": 1695,
	"./streaming/icons/spotify-i.svg": 1696,
	"./streaming/icons/youtube-logo.svg": 466,
	"./streaming/microsite/dark/amazonmusic.png": 377,
	"./streaming/microsite/dark/anghami.png": 885,
	"./streaming/microsite/dark/applemusic.png": 376,
	"./streaming/microsite/dark/audiomack.png": 597,
	"./streaming/microsite/dark/bandcamp.png": 380,
	"./streaming/microsite/dark/beatport.png": 599,
	"./streaming/microsite/dark/boomplay.png": 886,
	"./streaming/microsite/dark/deezer.png": 595,
	"./streaming/microsite/dark/even.png": 600,
	"./streaming/microsite/dark/googleplay.png": 378,
	"./streaming/microsite/dark/itunes.png": 592,
	"./streaming/microsite/dark/pandora.png": 596,
	"./streaming/microsite/dark/soundcloud.png": 593,
	"./streaming/microsite/dark/soundxyz.png": 871,
	"./streaming/microsite/dark/spotify.png": 591,
	"./streaming/microsite/dark/tidal.png": 594,
	"./streaming/microsite/dark/tiktok.png": 598,
	"./streaming/microsite/dark/youtube.png": 379,
	"./streaming/microsite/light.zip": 1697,
	"./streaming/microsite/light/amazonmusic.png": 602,
	"./streaming/microsite/light/anghami.png": 881,
	"./streaming/microsite/light/applemusic.png": 601,
	"./streaming/microsite/light/audiomack.png": 878,
	"./streaming/microsite/light/bandcamp.png": 880,
	"./streaming/microsite/light/beatport.png": 883,
	"./streaming/microsite/light/boomplay.png": 882,
	"./streaming/microsite/light/deezer.png": 876,
	"./streaming/microsite/light/even.png": 884,
	"./streaming/microsite/light/googleplay.png": 603,
	"./streaming/microsite/light/itunes.png": 873,
	"./streaming/microsite/light/pandora.png": 877,
	"./streaming/microsite/light/soundcloud.png": 874,
	"./streaming/microsite/light/soundxyz.png": 605,
	"./streaming/microsite/light/spotify.png": 872,
	"./streaming/microsite/light/tidal.png": 875,
	"./streaming/microsite/light/tiktok.png": 879,
	"./streaming/microsite/light/youtube.png": 604,
	"./streaming/small/amazon-bw.svg": 1698,
	"./streaming/small/amazon-store.png": 1699,
	"./streaming/small/apple-bw.svg": 1700,
	"./streaming/small/audiomack-bw.svg": 1701,
	"./streaming/small/deezer-bw.svg": 1702,
	"./streaming/small/soundcloud-bw.svg": 1703,
	"./streaming/small/spotify-bw.svg": 1704,
	"./streaming/small/tidal-bw.svg": 1705,
	"./streaming/small/youtube-bw.svg": 1706,
	"./streaming/square-icons/apple-sqr.svg": 660,
	"./streaming/square-icons/audiomack-sqr.svg": 661,
	"./streaming/square-icons/deezer-sqr.svg": 659,
	"./streaming/square-icons/soundcloud-sqr.svg": 662,
	"./streaming/square-icons/spotify-sqr.svg": 277,
	"./streaming/svg-logos/apple-service.svg": 653,
	"./streaming/svg-logos/audiomack-service.svg": 655,
	"./streaming/svg-logos/deezer-service.svg": 654,
	"./streaming/svg-logos/soundcloud-service.svg": 656,
	"./streaming/svg-logos/spotify-service.svg": 652,
	"./subscribe-arrow-icon.png": 1707,
	"./subscribe-gem-icon.png": 1708,
	"./subscribe-team-icon.png": 1709,
	"./symphony-s-logo-purple.png": 613,
	"./symphony-s-logo.png": 612,
	"./symphonyLogo.svg": 397,
	"./symphony_website.svg": 1710,
	"./tada.svg": 1711,
	"./teams.svg": 1712,
	"./tick-light.png": 400,
	"./tick-white.svg": 1713,
	"./tick.svg": 465,
	"./tiktok-black.svg": 1714,
	"./tiktok-bordered-icon.svg": 1715,
	"./tiktok-bw.svg": 1716,
	"./tiktok.svg": 673,
	"./traditional-icon-white.svg": 668,
	"./traditional-icon.svg": 667,
	"./trash-purple.svg": 1717,
	"./trash.svg": 1718,
	"./trusted-by.svg": 1719,
	"./twitter.svg": 460,
	"./ui-illustrations/chart.png": 1720,
	"./ui/Group 4 (1).png": 1721,
	"./ui/blur-graph.png": 398,
	"./ui/chevronrDown.svg": 1722,
	"./ui/close-button.svg": 1723,
	"./ui/close-white.svg": 1724,
	"./ui/cog.svg": 1725,
	"./ui/ig-boost-campaign-img.png": 410,
	"./ui/ig-boost-profile-visits-img.png": 651,
	"./ui/link-clicks-campaign-img.png": 1726,
	"./ui/loading-data.png": 679,
	"./ui/refresh.svg": 1727,
	"./ui/superboost-gray.svg": 1728,
	"./ui/superboost.svg": 1729,
	"./unlock-data-chart.svg": 401,
	"./unlock-data-geographies.svg": 179,
	"./unlock-presaves-by-day.svg": 278,
	"./up-green-arrow.svg": 638,
	"./upload-bg-green.svg": 1730,
	"./upload-icon-purple.svg": 1731,
	"./upload-icon-white.svg": 1732,
	"./upload.svg": 1733,
	"./user.svg": 399,
	"./video-key-green.svg": 1734,
	"./video-logo.svg": 1735,
	"./video-player.svg": 1736,
	"./visa-card.svg": 1737,
	"./website-feature.svg": 1738,
	"./website.svg": 1739,
	"./websiteIcon.svg": 1740,
	"./websiteThemes/data-collector-site.svg": 621,
	"./websiteThemes/music-site.svg": 620,
	"./websiteThemes/pause-button.png": 1741,
	"./websiteThemes/play-button.png": 1742,
	"./websiteThemes/presave-site.svg": 622,
	"./websiteThemes/tour.svg": 623,
	"./wikipedia.svg": 1743,
	"./yellow-star.png": 1744,
	"./youtube-bw.svg": 1745,
	"./youtube-white.svg": 1746,
	"./youtube.svg": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1482;